<div class="container wmaceess-additional-document-editor">

  <div class="previews">
    <!-- isAllSelected {{isAllSelected}} -->
    <div class="selectall">
   <mat-checkbox color="primary" [disabled]="!sideScroll" [checked]="isAllSelected" (change)="isAllSelected = !isAllSelected">Select all</mat-checkbox> 
  </div>
    <arb-pdf-page-preview
      *ngFor="let page of pages$ | async; let i = index"
      [page]="page"
      [file]="file"
      [editor]="editor"
      [isChecked]="isAllSelected || false" 
      [pageNumber]="i"
      [sideSelect]="!sideScroll"
      >
    </arb-pdf-page-preview>

  </div>

  <div
    #container
    [style.padding.px]="containerPadding"
    class="page-container">

  <canvas
    [style.max-width.px]="canvasMaxWidth"
    #canvas id="canvas"></canvas>
  <canvas
    #upperCanvas
    [style.top.px]="containerPadding"
    [style.left.px]="containerPadding"
    [style.max-width.px]="canvasMaxWidth"
    id="upper"
    style="touch-action: none;"  (drop)="drop($event)" (dragover)="allowDrop($event)">
  </canvas>

  </div>

</div>
